module.exports = __webpack_public_path__ + "static/media/logoMain.fa1bc3ed.svg";